import { convertValue, formatPercentageValue } from 'src/utils/number';

/**
 * Formatação compartilhada pelos widgets de concentração do cockpit
 * (cards Top 1/5/10/25 e gráfico resumido por fundo).
 */

export function formatConcentrationCurrency(
  value: number,
  fractionDigits?: number,
) {
  const maximumFractionDigits = fractionDigits ?? 1;
  const minimumFractionDigits = fractionDigits ?? 0;

  return convertValue(
    value,
    '',
    true,
    'currency',
    'BRL',
    maximumFractionDigits,
    minimumFractionDigits,
  );
}

export function formatConcentrationPercentage(value: number, digits = 1) {
  return formatPercentageValue(value, digits);
}

export function formatConcentrationCompetency(competencyDate?: string | null) {
  if (!competencyDate) return null;

  const [year, month] = competencyDate.split('-');
  const months = [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez',
  ];
  const monthIndex = Number(month) - 1;

  if (months[monthIndex] === undefined) return null;

  return `${months[monthIndex]}/${year}`;
}

export function wrapConcentrationTooltipLabel(
  label: string,
  maxLength: number,
): string[] {
  const lines: string[] = [];
  let currentLine = '';

  label.split(/\s+/).forEach((word) => {
    while (word.length > maxLength) {
      if (currentLine) {
        lines.push(currentLine);
        currentLine = '';
      }
      lines.push(word.slice(0, maxLength));
      word = word.slice(maxLength);
    }

    const nextLine = currentLine ? `${currentLine} ${word}` : word;
    if (nextLine.length > maxLength) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine = nextLine;
    }
  });

  if (currentLine) lines.push(currentLine);
  return lines;
}
